import { createSlice } from '@reduxjs/toolkit';
import { fetchServiceProviders } from './serviceProviderThunks';

const initialState = { listLight: [], isFetchingListLight: false, fetchListLightError: null };

export const serviceProviderSlice = createSlice({
  name: 'serviceProvider',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceProviders.pending, (state) => {
        state.isFetchingListLight = true;
        state.fetchListLightError = null;
      })
      .addCase(fetchServiceProviders.fulfilled, (state, action) => {
        state.isFetchingListLight = false;
        state.fetchListLightError = null;
        state.listLight = action.payload;
      })
      .addCase(fetchServiceProviders.rejected, (state) => {
        state.isFetchingListLight = false;
        state.fetchListLightError = 500;
      });
  },
});

export default serviceProviderSlice.reducer;
